exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-facultad-js": () => import("./../../../src/pages/facultad.js" /* webpackChunkName: "component---src-pages-facultad-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-preparatoria-js": () => import("./../../../src/pages/preparatoria.js" /* webpackChunkName: "component---src-pages-preparatoria-js" */)
}

